import { Icon } from "@iconify/react";
import { Box, IconButton, Typography } from "@mui/material";
import React, { useState } from "react";
import AmazonAvailable from "../../products/available_at_amazon_US_EN_logo_stacked_RGB_SQUID.png"

let affiliateLinks = {
  "48500205853": {
    link: "https://amzn.to/3XQEEJo",
    price: "2.69",
    estimatedDelivery: 1,
  },
  "818253779570": {
    link: "https://amzn.to/4lFqDsj",
    price: "58.55",
    estimatedDelivery: 9,
  },
  "691035387039": {
    link: "https://amzn.to/3E2Jqga",
    price: "15.48",
    estimatedDelivery: 1,
  },
  "696545186097": {
    link: "https://amzn.to/44hkY5b",
    price: "13.49",
    estimatedDelivery: 1,
  },
  "048500205716": {
    link: "https://amzn.to/444rGvx",
    price: "3.33",
    estimatedDelivery: 1,
  },
  "3378872129776": {
    link: "https://amzn.to/3XCgrq5",
    price: "15.96",
    estimatedDelivery: 9,
  },
  "016000124998": {
    link: "https://amzn.to/3FHnhnS",
    price: "3.66",
    estimatedDelivery: 5,
  },
};

const OnlineStoresMobile = ({ product }) => {
  const [open, setOpen] = useState(false);

  const upcData = affiliateLinks[String(product.upc)];
  const stores = upcData
    ? [
        {
          id: "amazon",
          name: "Amazon",
          image: AmazonAvailable,
          price: `$${upcData.price}`,
          link: upcData.link,
          estimatedDelivery: `${upcData.estimatedDelivery} day${upcData.estimatedDelivery > 1 ? "s" : ""}`,
        },
      ]
    : [];

  const [selectedStore, setSelectedStore] = useState(stores[0] || null);

  return (
    <Box sx={{pt: '28px', px: '16px'}}>
      {stores.length > 0 ? (
        stores.map((store, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "white",
              borderRadius: "12px",
              padding: "12px 16px",
              marginBottom: "12px",
              cursor: "pointer",
              width: "100%",
            }}
            onClick={() => setSelectedStore(store)}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <img
                src={store.image}
                alt={store.name}
                style={{
                  width: "56px",
                  height: "56px",
                  objectFit: "contain",
                  marginRight: "12px",
                }}
              />
              <Box>
                <Typography
                  sx={{ fontSize: "14px", fontWeight: 500, color: "#0E2B5D" }}
                >
                  Price: {store.price}
                </Typography>
                <Typography
                  sx={{ fontSize: "14px", color: "#0E2B5D", marginTop: "2px" }}
                >
                  Estimated Delivery: {store.estimatedDelivery}
                </Typography>
              </Box>
            </Box>
            <IconButton
              href={selectedStore.link}
              sx={{
                width: "83px",
                height: "35px",
                borderRadius: "30px",
                border: "2px solid #E5E5E5",
                gap: 1,
              }}
            >
              <Icon icon={"mi:shopping-cart-add"} style={{ color: "#205375" }} />
              <Typography variant="h6" sx={{ color: "#205375", fontSize: "14px" }}>
                Buy
              </Typography>
            </IconButton>
            
          </Box>
        ))
        ) : (
          <Typography variant="body2" sx={{ textAlign: "center" }}>
            No stores available.
          </Typography>
        )}
    </Box>
  );
};

export default OnlineStoresMobile;
